import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.4.29_typescript@5.9.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];